/* eslint-disable */

import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,
    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgProfileMenu = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 30 30">
        <G fill="none" fill-rule="evenodd" transform="translate(1 1)">
            <Circle cx="14" cy="14" r="14" stroke="#FFFFFF" />
            <G transform="translate(6 4)">
                <Circle cx="7.5" cy="4.5" r="4.5" stroke="#FFFFFF" />
                <Path stroke="#979797" d="" />
                <Path stroke="#FFFFFF" d="M5,8 C5,8 1.55586568e-09,10 1.38777878e-17,16" />
                <Path stroke="#FFFFFF" d="M15.0176726,8.02674627 C15.0176726,8.02674627 10.0176726,10.0267463 10.0176726,16.0267463" transform="matrix(-1 0 0 1 25.035 0)" />
                <Path stroke="#FFFFFF" d="M0.0176242219,15.5977365 C0.0176242219,15.5977365 6.01762422,21.5977365 15.0176242,15.5977365" />
            </G>
        </G>
    </Svg>)
}

